import { getTranslation } from "utils/translation";
import { Dialog } from "components/dialog/Dialog";
import { DialogFooter } from "components/dialog/DialogFooter/DialogFooter";
import { DialogHeader } from "components/dialog/DialogHeader/DialogHeader";
import { DialogBody } from "components/dialog/DialogMain/DialogBody/DialogBody";
import { DialogMain } from "components/dialog/DialogMain/DialogMain";
import { useDialogContext } from "components/dialog/controller/DialogProvider";

export const LogoutDialog = () => {
  const { dialogProps } = useDialogContext();
  return (
    <Dialog size="small" state="info">
      <DialogHeader>{getTranslation("resource", "MESSAGE")}</DialogHeader>
      <DialogMain>
        <DialogBody>
          {getTranslation("message", "CONFIRM.ARE_YOU_WANT_LOGOUT")}
        </DialogBody>
      </DialogMain>
      <DialogFooter
        button={{
          label: getTranslation("resource", "LOGOUT"),
          onClick: dialogProps.buttonClick,
        }}
      />
    </Dialog>
  );
};
